import React, { useState } from "react";
import QRCode from "qrcode.react";
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { connect } from "react-redux";

const styles = theme => ({
    root: {
        display: "flex",
        padding: "2%",
        alignItems: "center",
        justifyContent: "center",
       },
    inputs: {
        display: "grid",
        width: "70%",
    },
    qr:{
        display: "grid",
        padding: '20px',
    },   
})

const QRCodeGenerator = (props) => {
    const { translations, classes } = props;
    const options = [
        {displayValue : 'Start Erasure', value : 'StartErasure'},
        {displayValue : 'External Data', value : 'ExternalData'},
        {displayValue : 'Employee Data', value : 'EmployeeData'},
    ];

    const [text, setText] = useState('');
    const [choosen, setChoosen] = useState("StartErasure");

    const downloadQRCode = () => {
        const canvas = document.getElementById('qr');
        const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `${qrValue}.png`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }; 
   
    const handleChange = e => {
        setChoosen(e.target.value);
    };
    const qrValue = `<${choosen}>${text}</${choosen}>`;

    return (
        <div className = {classes.root}>
            <div className={classes.inputs}>
                <TextField label={translations["enter_text_here"] || "Enter Text Here"} onChange={(e) => setText(e.target.value)}/>
                <FormControl sx = {{m:1 }}>
                    <Select 
                    value={choosen}
                    onChange = {handleChange}>
                        {options.map((option) => (
                            <MenuItem key  = {option.value} value = {option.value}>{option.displayValue}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className={classes.qr}>
                <QRCode id='qr' value = {qrValue}/>
                <Button variant="contained" onClick={downloadQRCode}>{translations["download"] || "Download"}</Button>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(QRCodeGenerator));
